import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'

export const Recommendations = ({ recommendations }) => {
  return (recommendations.items || [])
    .sort((a) => (a.completedAt ? 1 : -1))
    .map(({ name, description, completedAt }) => {
      return (
        <Grid item xs={12}>
          <Card>
            <SoftBox px={3} py={2}>
              <SoftTypography
                textAlign="left"
                variant="h6"
                component="div"
                color="dark"
                fontWeight="bold"
                style={{
                  textDecoration: completedAt ? 'line-through' : 'none',
                }}
              >
                {name}
              </SoftTypography>
              <SoftTypography
                textAlign="left"
                color="text.secondary"
                variant="body2"
                style={{
                  textDecoration: completedAt ? 'line-through' : 'none',
                }}
              >
                {description}
              </SoftTypography>
            </SoftBox>
          </Card>
        </Grid>
      )
    })
}
